import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type getExchangeRatesDataType = {
  successCallback?: Function;
  errorCallback?: Function;
  resultKey: string;
};

export default ({ successCallback, errorCallback, resultKey = 'getExchangeRatesResponse' }: getExchangeRatesDataType) =>
  requestAsync({
    url: endpoints.getExchangeRatesUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getExchangeRatesUrl(),
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
